<template>
  <div class="modal trader-info right fade" id="trader-info" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Column options</h5>
          <button type="button" class="close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <span style="margin-left: 12px; padding: 10px;">
          Utilize checkboxes to add or remove columns. To rearrange the column order, simply drag and drop a field.
        </span>
        <div class="modal-body" style="padding: 25px;">
          <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt="" /></div>

          <b-tabs>
            <b-tab title="Columns" active>
              <div class="d-flex justify-content-between" style="padding: 10px;">
                <div>
                  <!-- <input type="checkbox" v-model="selectAll" @change="selectAllColumns">
                    <label>Select All</label> -->
                </div>
                <div>
                  <button @click="resetColumns" class="btn btn-sm btn-secondary">Reset</button>
                </div>
              </div>


              <div class="list-group list-group-light">
                <draggable class="list-group" tag="ul" v-model="columnHeaders" v-bind="dragOptions"
                  @start="isDragging = true" @end="isDragging = false">
                  <transition-group type="transition" name="flip-list">
                    <li class="list-group-item" v-for="(element, index) in columnHeaders" :key="'column' + index">
                      <input v-show="!element.isDefault" class="form-check-input" type="checkbox"
                        v-bind:id="'checkboxExample' + element.name" v-bind:name="'checkboxExample' + element.name"
                        v-model="element.isSelected" />
                      <label class="form-check-label" for="checkboxExample1">{{ element.name.replace(/_/g, ' ') }}</label>
                      <i data-v-3eb58570="" class="fas fa-grip-vertical"
                        style=" visibility: hidden; position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: grab;"></i>
                    </li>
                  </transition-group>
                </draggable>
              </div>
            </b-tab>
            <b-tab title="Sorting">
              <form class="mt-4">
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label for="inputEmail4">
                      COLUMN
                    </label>
                    <select class="form-control cursor-pointer" v-model="sortColumn">
                      <option v-for="header in columnHeaders" :key="header.key"
                        :value="header.key">
                        {{ header.name.replace(/_/g, ' ') }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-5">
                    <label for="inputEmail4">
                      SORT ORDER
                    </label>
                    <select class="form-control cursor-pointer" v-model="sortOrder">
                      <option value="ASC">ASC</option>
                      <option value="DESC">DESC</option>
                    </select>
                  </div>
                </div>
                  <hr>

              </form>
            </b-tab>
          </b-tabs>

        </div>
        <div class="modal-footer bid">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">Close</button>
          <button type="button" class="btn btn-primary" @click="save()">APPLY</button>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import config from "@/config";
import authService from "@/authService";
import baColumnOptions from "@/baColumnOptions";

export default {
  name: 'Columnoptions',
  components: {
    draggable
  },
  props: [],
  data() {
    return {
      columnHeaders: [],
      enabled: true,
      dragging: false,
      loading: false,
      columnSorts: [],
      sortColumn: "",
      sortOrder: "",
      userSettings : [],

    };
  },
  computed: {
    draggingInfo() {
      return this.dragging ? "under drag" : "";
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    }
  },

  methods: {
    resetColumns() {
      var message = `Are you sure you want to reset the columns?`;
      this.$confirm(message, "", "question", { confirmButtonText: "YES", cancelButtonText: "NO" }).then(() => {
        this.columnHeaders = this.columnHeaders.map(column => {
        column.selected = false; // Set selected to false
        return column;
      }).sort((a, b) => a.defaultorder - b.defaultorder);
      });

    },
    save() {
      this.loading = true;
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      let data = {
        "selectedHeaders": this.columnHeaders,
        "sortColumn": this.sortColumn,
        "sortOrder": this.sortOrder
      }
      this.$http
        .post(
          config.baseUrlAutoBidder +
          "/bidwanted/holding-column-options-save?cognitoSub="+authService.getUser().cognitoSub, data,
          auth
        )
        .then(() => {
          this.$emit('close');
        })
        .catch((e) => {
          console.log(e);
        });
      // const selectedHeaders = this.columnHeaders.filter(header => header.isSelected === true);
      // this.$emit('close');
      // let columnData = {};
      // columnData.selectedHeaders = selectedHeaders;
      // columnData.sortColumn = this.sortColumn;
      // columnData.sortOrder = this.sortOrder;
      // this.$emit('applyColumn', columnData);
    },
    getSavedColumnOptions() {
      const auth = {
          headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
          .get(
          config.baseUrlBidSide +
              "/tradebook/setting-list?cognitoSub="+authService.getUser().cognitoSub,
              auth
          )
          .then(result => {
              this.userSettings = result.data;
              this.userSettings.forEach(element => {

                if(element.setting == "INVENTORY_HOLDING_COLUMN_ORDER"){
                  let columnData      =   JSON.parse(element.value);
                  this.columnHeaders  =   columnData.selectedHeaders;
                  this.sortColumn     =   columnData.sortColumn;
                  this.sortOrder      =   columnData.sortOrder;
                } 
                     
              }); 
              if(this.columnHeaders.length == 0){
                this.columnHeaders = [...baColumnOptions]
              }  
          })
          .catch(e => {
              console.log(e);
          });
    },

  },
  mounted() {
    this.getSavedColumnOptions()
  }
};
</script>
<style scoped>
.list-group-item {
  text-align: left;
  text-transform: uppercase;
}

.button {
  margin-top: 35px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
  padding: 0.3rem 1.9rem
}

.list-group-item i {
  cursor: pointer;
  color: #525f7f
}

li.list-group-item:hover {
  background-color: #f5f5f5;
  /* Change this color to your desired highlight color */

}

li.list-group-item:hover i {
  visibility: visible !important;
}

.list-group {
  overflow-y: scroll;
  max-height: 525px;
}
button{
  min-width: 5px;
}
</style>